import { render, staticRenderFns } from "./Q3.vue?vue&type=template&id=1fbd63a8&scoped=true&"
import script from "./Q3.vue?vue&type=script&lang=js&"
export * from "./Q3.vue?vue&type=script&lang=js&"
import style0 from "./Q3.vue?vue&type=style&index=0&id=1fbd63a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd63a8",
  null
  
)

export default component.exports